/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { TextField } from '@material-ui/core';

export const BuscarRegras = styled(TextField)`
  width: 70%;
  background-color: #fff;
`;
